import { DialogTitle, ListItemText, styled } from '@mui/material';

export const BookingsModalDialogTitle = styled(DialogTitle)({
  textAlign: 'center',
  color: 'white',
  height: '5rem',
  background: 'linear-gradient(100deg, rgba(95,81,166,1) 81%, rgba(75,75,75,1) 19%);',
});

export const BookingsModalListItemText = styled(ListItemText)({
    flex: 'none',

    '& span': {
      fontSize: 14,
    },

    '& p': {
      fontSize: 12,
    },
  });


